/**
 * Do NOT MODIFY THIS FILE OR ANY OTHER FILE IN THE __generated__ DIRECTORY.
 *
 * Generated using StyleDictionary on Thu, 05 Nov 2026 05:44:36 GMT.
 */

export const lightTheme = {
  colors: {
    background: 'var(--colors-background)',
    text: 'var(--colors-text)',
    primary: 'var(--colors-primary)',
    secondary: 'var(--colors-secondary)',
    brand: 'var(--colors-brand)',
    accent: 'var(--colors-accent)',
    danger: 'var(--colors-danger)',
    warning: 'var(--colors-warning)',
    success: 'var(--colors-success)',
    info: 'var(--colors-info)',
    variant: [
      'var(--primitives-colour-decorative-pastel-k1)',
      'var(--primitives-colour-decorative-pastel-k2)',
      'var(--primitives-colour-decorative-pastel-k3)',
      'var(--primitives-colour-decorative-pastel-k4)',
      'var(--primitives-colour-decorative-pastel-k5)',
      'var(--primitives-colour-decorative-pastel-k6)',
      'var(--primitives-colour-decorative-pastel-k7)',
    ],
  },
  components: {
    badge: {
      bold: {
        primary: {
          surfaceColor: 'var(--components-badge-bold-primary-surface-color)',
        },
        'primary-inverse': {
          surfaceColor:
            'var(--components-badge-bold-primary-inverse-surface-color)',
        },
        secondary: {
          surfaceColor: 'var(--components-badge-bold-secondary-surface-color)',
        },
        'secondary-inverse': {
          surfaceColor:
            'var(--components-badge-bold-secondary-inverse-surface-color)',
        },
        neutral: {
          surfaceColor: 'var(--components-badge-bold-neutral-surface-color)',
        },
        'neutral-inverse': {
          surfaceColor:
            'var(--components-badge-bold-neutral-inverse-surface-color)',
        },
        critical: {
          surfaceColor: 'var(--components-badge-bold-critical-surface-color)',
        },
        'critical-inverse': {
          surfaceColor:
            'var(--components-badge-bold-critical-inverse-surface-color)',
        },
        positive: {
          surfaceColor: 'var(--components-badge-bold-positive-surface-color)',
        },
        cautious: {
          surfaceColor: 'var(--components-badge-bold-cautious-surface-color)',
        },
        informative: {
          surfaceColor:
            'var(--components-badge-bold-informative-surface-color)',
        },
        disabled: {
          surfaceColor: 'var(--components-badge-bold-disabled-surface-color)',
        },
      },
    },
    chip: {
      borderRadius: 'var(--components-chip-border-radius)',
      filled: {
        surfaceColor: 'var(--components-chip-filled-surface-color)',
        borderColor: 'var(--components-chip-filled-border-color)',
        iconColor: 'var(--components-chip-filled-icon-color)',
        textColor: 'var(--components-chip-filled-text-color)',
        interactions: {
          hover: {
            surfaceColor:
              'var(--components-chip-filled-interactions-hover-surface-color)',
          },
          pressed: {
            surfaceColor:
              'var(--components-chip-filled-interactions-pressed-surface-color)',
          },
        },
        active: {
          surfaceColor: 'var(--components-chip-filled-active-surface-color)',
          borderColor: 'var(--components-chip-filled-active-border-color)',
          iconColor: 'var(--components-chip-filled-active-icon-color)',
          textColor: 'var(--components-chip-filled-active-text-color)',
          interactions: {
            hover: {
              surfaceColor:
                'var(--components-chip-filled-active-interactions-hover-surface-color)',
            },
            pressed: {
              surfaceColor:
                'var(--components-chip-filled-active-interactions-pressed-surface-color)',
            },
          },
        },
      },
      outline: {
        surfaceColor: 'var(--components-chip-outline-surface-color)',
        borderColor: 'var(--components-chip-outline-border-color)',
        iconColor: 'var(--components-chip-outline-icon-color)',
        textColor: 'var(--components-chip-outline-text-color)',
        interactions: {
          hover: {
            surfaceColor:
              'var(--components-chip-outline-interactions-hover-surface-color)',
          },
          pressed: {
            surfaceColor:
              'var(--components-chip-outline-interactions-pressed-surface-color)',
          },
        },
        active: {
          surfaceColor: 'var(--components-chip-outline-active-surface-color)',
          borderColor: 'var(--components-chip-outline-active-border-color)',
          iconColor: 'var(--components-chip-outline-active-icon-color)',
          textColor: 'var(--components-chip-outline-active-text-color)',
          interactions: {
            hover: {
              surfaceColor:
                'var(--components-chip-outline-active-interactions-hover-surface-color)',
            },
            pressed: {
              surfaceColor:
                'var(--components-chip-outline-active-interactions-pressed-surface-color)',
            },
          },
        },
      },
      small: {
        height: 'var(--components-chip-small-height)',
        paddingInline: 'var(--components-chip-small-padding-inline)',
      },
      medium: {
        height: 'var(--components-chip-medium-height)',
        paddingInline: 'var(--components-chip-medium-padding-inline)',
      },
      disabled: {
        surfaceColor: 'var(--components-chip-disabled-surface-color)',
        textColor: 'var(--components-chip-disabled-text-color)',
        iconColor: 'var(--components-chip-disabled-icon-color)',
      },
    },
  },
  name: 'var(--name)',
  borderWidth: {
    standard: 'var(--border-width-standard)',
    large: 'var(--border-width-large)',
  },
  breakpoints: {
    small: 'var(--breakpoints-small)',
    medium: 'var(--breakpoints-medium)',
    large: 'var(--breakpoints-large)',
    xlarge: 'var(--breakpoints-xlarge)',
  },
  contentWidth: {
    xsmall: 'var(--content-width-xsmall)',
    small: 'var(--content-width-small)',
    medium: 'var(--content-width-medium)',
    large: 'var(--content-width-large)',
    xlarge: 'var(--content-width-xlarge)',
  },
  elevation: {
    card: 'var(--elevation-card)',
    dropdown: 'var(--elevation-dropdown)',
    sticky: 'var(--elevation-sticky)',
    popover: 'var(--elevation-popover)',
    modal: 'var(--elevation-modal)',
    toast: 'var(--elevation-toast)',
  },
  shadow: {
    xsmall: 'var(--shadow-xsmall)',
    small: 'var(--shadow-small)',
    medium: 'var(--shadow-medium)',
    large: 'var(--shadow-large)',
    xlarge: 'var(--shadow-xlarge)',
  },
  radii: {
    none: 'var(--radii-none)',
    xsmall: 'var(--radii-xsmall)',
    small: 'var(--radii-small)',
    medium: 'var(--radii-medium)',
    large: 'var(--radii-large)',
    xlarge: 'var(--radii-xlarge)',
    full: 'var(--radii-full)',
  },
  semantic: {
    colour: {
      primary: {
        foreground: 'var(--semantic-colour-primary-foreground)',
        background: 'var(--semantic-colour-primary-background)',
        container: {
          foreground: 'var(--semantic-colour-primary-container-foreground)',
          background: 'var(--semantic-colour-primary-container-background)',
          interactions: {
            hover:
              'var(--semantic-colour-primary-container-interactions-hover)',
            focused:
              'var(--semantic-colour-primary-container-interactions-focused)',
            pressed:
              'var(--semantic-colour-primary-container-interactions-pressed)',
          },
        },
        inverse: {
          foreground: 'var(--semantic-colour-primary-inverse-foreground)',
          background: 'var(--semantic-colour-primary-inverse-background)',
          interactions: {
            hover: 'var(--semantic-colour-primary-inverse-interactions-hover)',
            focused:
              'var(--semantic-colour-primary-inverse-interactions-focused)',
            pressed:
              'var(--semantic-colour-primary-inverse-interactions-pressed)',
          },
        },
        interactions: {
          hover: 'var(--semantic-colour-primary-interactions-hover)',
          focused: 'var(--semantic-colour-primary-interactions-focused)',
          pressed: 'var(--semantic-colour-primary-interactions-pressed)',
        },
      },
      secondary: {
        foreground: 'var(--semantic-colour-secondary-foreground)',
        background: 'var(--semantic-colour-secondary-background)',
        border: 'var(--semantic-colour-secondary-border)',
        container: {
          foreground: 'var(--semantic-colour-secondary-container-foreground)',
          background: 'var(--semantic-colour-secondary-container-background)',
          interactions: {
            hover:
              'var(--semantic-colour-secondary-container-interactions-hover)',
            focused:
              'var(--semantic-colour-secondary-container-interactions-focused)',
            pressed:
              'var(--semantic-colour-secondary-container-interactions-pressed)',
          },
        },
        inverse: {
          foreground: 'var(--semantic-colour-secondary-inverse-foreground)',
          background: 'var(--semantic-colour-secondary-inverse-background)',
          interactions: {
            hover:
              'var(--semantic-colour-secondary-inverse-interactions-hover)',
            focused:
              'var(--semantic-colour-secondary-inverse-interactions-focused)',
            pressed:
              'var(--semantic-colour-secondary-inverse-interactions-pressed)',
          },
        },
        interactions: {
          hover: 'var(--semantic-colour-secondary-interactions-hover)',
          focused: 'var(--semantic-colour-secondary-interactions-focused)',
          pressed: 'var(--semantic-colour-secondary-interactions-pressed)',
        },
        accent: 'var(--semantic-colour-secondary-accent)',
      },
      neutral: {
        foreground: 'var(--semantic-colour-neutral-foreground)',
        background: 'var(--semantic-colour-neutral-background)',
        border: 'var(--semantic-colour-neutral-border)',
        mono: { monotone: 'var(--semantic-colour-neutral-mono-monotone)' },
        container: {
          foreground: 'var(--semantic-colour-neutral-container-foreground)',
          background: 'var(--semantic-colour-neutral-container-background)',
          interactions: {
            hover:
              'var(--semantic-colour-neutral-container-interactions-hover)',
            focused:
              'var(--semantic-colour-neutral-container-interactions-focused)',
            pressed:
              'var(--semantic-colour-neutral-container-interactions-pressed)',
          },
        },
        inverse: {
          foreground: 'var(--semantic-colour-neutral-inverse-foreground)',
          background: 'var(--semantic-colour-neutral-inverse-background)',
          interactions: {
            hover: 'var(--semantic-colour-neutral-inverse-interactions-hover)',
            focused:
              'var(--semantic-colour-neutral-inverse-interactions-focused)',
            pressed:
              'var(--semantic-colour-neutral-inverse-interactions-pressed)',
          },
        },
        interactions: {
          hover: 'var(--semantic-colour-neutral-interactions-hover)',
          focused: 'var(--semantic-colour-neutral-interactions-focused)',
          pressed: 'var(--semantic-colour-neutral-interactions-pressed)',
        },
      },
      reserved: {
        info: {
          foreground: 'var(--semantic-colour-reserved-info-foreground)',
          background: 'var(--semantic-colour-reserved-info-background)',
          container: {
            foreground:
              'var(--semantic-colour-reserved-info-container-foreground)',
            background:
              'var(--semantic-colour-reserved-info-container-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-info-container-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-info-container-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-info-container-interactions-pressed)',
            },
          },
          inverse: {
            foreground:
              'var(--semantic-colour-reserved-info-inverse-foreground)',
            background:
              'var(--semantic-colour-reserved-info-inverse-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-info-inverse-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-info-inverse-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-info-inverse-interactions-pressed)',
            },
          },
          interactions: {
            hover: 'var(--semantic-colour-reserved-info-interactions-hover)',
            focused:
              'var(--semantic-colour-reserved-info-interactions-focused)',
            pressed:
              'var(--semantic-colour-reserved-info-interactions-pressed)',
          },
        },
        critical: {
          foreground: 'var(--semantic-colour-reserved-critical-foreground)',
          background: 'var(--semantic-colour-reserved-critical-background)',
          container: {
            foreground:
              'var(--semantic-colour-reserved-critical-container-foreground)',
            background:
              'var(--semantic-colour-reserved-critical-container-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-critical-container-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-critical-container-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-critical-container-interactions-pressed)',
            },
          },
          inverse: {
            foreground:
              'var(--semantic-colour-reserved-critical-inverse-foreground)',
            background:
              'var(--semantic-colour-reserved-critical-inverse-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-critical-inverse-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-critical-inverse-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-critical-inverse-interactions-pressed)',
            },
          },
          interactions: {
            hover:
              'var(--semantic-colour-reserved-critical-interactions-hover)',
            focused:
              'var(--semantic-colour-reserved-critical-interactions-focused)',
            pressed:
              'var(--semantic-colour-reserved-critical-interactions-pressed)',
          },
        },
        warning: {
          foreground: 'var(--semantic-colour-reserved-warning-foreground)',
          background: 'var(--semantic-colour-reserved-warning-background)',
          container: {
            foreground:
              'var(--semantic-colour-reserved-warning-container-foreground)',
            background:
              'var(--semantic-colour-reserved-warning-container-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-warning-container-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-warning-container-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-warning-container-interactions-pressed)',
            },
          },
          inverse: {
            foreground:
              'var(--semantic-colour-reserved-warning-inverse-foreground)',
            background:
              'var(--semantic-colour-reserved-warning-inverse-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-warning-inverse-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-warning-inverse-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-warning-inverse-interactions-pressed)',
            },
          },
          interactions: {
            hover: 'var(--semantic-colour-reserved-warning-interactions-hover)',
            focused:
              'var(--semantic-colour-reserved-warning-interactions-focused)',
            pressed:
              'var(--semantic-colour-reserved-warning-interactions-pressed)',
          },
        },
        success: {
          foreground: 'var(--semantic-colour-reserved-success-foreground)',
          background: 'var(--semantic-colour-reserved-success-background)',
          container: {
            foreground:
              'var(--semantic-colour-reserved-success-container-foreground)',
            background:
              'var(--semantic-colour-reserved-success-container-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-success-container-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-success-container-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-success-container-interactions-pressed)',
            },
          },
          inverse: {
            foreground:
              'var(--semantic-colour-reserved-success-inverse-foreground)',
            background:
              'var(--semantic-colour-reserved-success-inverse-background)',
            interactions: {
              hover:
                'var(--semantic-colour-reserved-success-inverse-interactions-hover)',
              focused:
                'var(--semantic-colour-reserved-success-inverse-interactions-focused)',
              pressed:
                'var(--semantic-colour-reserved-success-inverse-interactions-pressed)',
            },
          },
          interactions: {
            hover: 'var(--semantic-colour-reserved-success-interactions-hover)',
            focused:
              'var(--semantic-colour-reserved-success-interactions-focused)',
            pressed:
              'var(--semantic-colour-reserved-success-interactions-pressed)',
          },
        },
      },
      surface: {
        neutral: {
          background: 'var(--semantic-colour-surface-neutral-background)',
          background1: 'var(--semantic-colour-surface-neutral-background1)',
          background2: 'var(--semantic-colour-surface-neutral-background2)',
          background3: 'var(--semantic-colour-surface-neutral-background3)',
          background4: 'var(--semantic-colour-surface-neutral-background4)',
          foregroundPrimary:
            'var(--semantic-colour-surface-neutral-foreground-primary)',
          border: 'var(--semantic-colour-surface-neutral-border)',
          borderStrong: 'var(--semantic-colour-surface-neutral-border-strong)',
        },
        primary: {
          background1: 'var(--semantic-colour-surface-primary-background1)',
        },
        tonal: {
          background1: 'var(--semantic-colour-surface-tonal-background1)',
          background2: 'var(--semantic-colour-surface-tonal-background2)',
          background3: 'var(--semantic-colour-surface-tonal-background3)',
          background4: 'var(--semantic-colour-surface-tonal-background4)',
        },
      },
      text: {
        textPrimary: 'var(--semantic-colour-text-text-primary)',
        textBody: 'var(--semantic-colour-text-text-body)',
        textSecondary: 'var(--semantic-colour-text-text-secondary)',
        textTertiary: 'var(--semantic-colour-text-text-tertiary)',
        textPlaceholder: 'var(--semantic-colour-text-text-placeholder)',
        textHeadings: 'var(--semantic-colour-text-text-headings)',
        textInverted: 'var(--semantic-colour-text-text-inverted)',
        textDisabled: 'var(--semantic-colour-text-text-disabled)',
        textLink: 'var(--semantic-colour-text-text-link)',
        reserved: {
          info: 'var(--semantic-colour-text-reserved-info)',
          critical: 'var(--semantic-colour-text-reserved-critical)',
          warning: 'var(--semantic-colour-text-reserved-warning)',
          success: 'var(--semantic-colour-text-reserved-success)',
        },
      },
      decorative: {
        yellow: {
          foreground: 'var(--semantic-colour-decorative-yellow-foreground)',
          surface: 'var(--semantic-colour-decorative-yellow-surface)',
        },
        green: {
          foreground: 'var(--semantic-colour-decorative-green-foreground)',
          surface: 'var(--semantic-colour-decorative-green-surface)',
        },
        teal: {
          foreground: 'var(--semantic-colour-decorative-teal-foreground)',
          surface: 'var(--semantic-colour-decorative-teal-surface)',
        },
        blue: {
          foreground: 'var(--semantic-colour-decorative-blue-foreground)',
          surface: 'var(--semantic-colour-decorative-blue-surface)',
        },
        purple: {
          foreground: 'var(--semantic-colour-decorative-purple-foreground)',
          surface: 'var(--semantic-colour-decorative-purple-surface)',
        },
        pink: {
          foreground: 'var(--semantic-colour-decorative-pink-foreground)',
          surface: 'var(--semantic-colour-decorative-pink-surface)',
        },
        coral: {
          foreground: 'var(--semantic-colour-decorative-coral-foreground)',
          surface: 'var(--semantic-colour-decorative-coral-surface)',
        },
      },
    },
  },
  sizes: {
    xsmall: {
      fontSizeDisplay: 'var(--sizes-xsmall-font-size-display)',
      fontSizeText: 'var(--sizes-xsmall-font-size-text)',
      borderRadius: 'var(--sizes-xsmall-border-radius)',
      boxSize: 'var(--sizes-xsmall-box-size)',
      gap: 'var(--sizes-xsmall-gap)',
      paddingX: 'var(--sizes-xsmall-padding-x)',
      paddingY: 'var(--sizes-xsmall-padding-y)',
    },
    small: {
      fontSizeDisplay: 'var(--sizes-small-font-size-display)',
      fontSizeText: 'var(--sizes-small-font-size-text)',
      borderRadius: 'var(--sizes-small-border-radius)',
      boxSize: 'var(--sizes-small-box-size)',
      gap: 'var(--sizes-small-gap)',
      paddingX: 'var(--sizes-small-padding-x)',
      paddingY: 'var(--sizes-small-padding-y)',
    },
    medium: {
      fontSizeDisplay: 'var(--sizes-medium-font-size-display)',
      fontSizeText: 'var(--sizes-medium-font-size-text)',
      borderRadius: 'var(--sizes-medium-border-radius)',
      boxSize: 'var(--sizes-medium-box-size)',
      gap: 'var(--sizes-medium-gap)',
      paddingX: 'var(--sizes-medium-padding-x)',
      paddingY: 'var(--sizes-medium-padding-y)',
    },
  },
  sizing: {
    xxsmall: 'var(--sizing-xxsmall)',
    xsmall: 'var(--sizing-xsmall)',
    small: 'var(--sizing-small)',
    base: 'var(--sizing-base)',
    medium: 'var(--sizing-medium)',
    large: 'var(--sizing-large)',
    xlarge: 'var(--sizing-xlarge)',
  },
  spacing: {
    none: 'var(--spacing-none)',
    xxsmall: 'var(--spacing-xxsmall)',
    xsmall: 'var(--spacing-xsmall)',
    small: 'var(--spacing-small)',
    medium: 'var(--spacing-medium)',
    large: 'var(--spacing-large)',
    xlarge: 'var(--spacing-xlarge)',
    xxlarge: 'var(--spacing-xxlarge)',
    k3xlarge: 'var(--spacing-k3xlarge)',
  },
  typography: {
    fontFamily: {
      monospace:
        '"SFMono-Medium","SF Mono","Segoe UI Mono","Roboto Mono","Ubuntu Mono", Menlo, Consolas, Courier, monospace',
      body:
        'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
      heading:
        'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif',
    },
    fontSize: {
      xsmall: '0.75rem',
      small: '0.875rem',
      medium: '1rem',
      large: '1.125rem',
      xlarge: '1.25rem',
      xxlarge: '1.5rem',
      xxxlarge: '1.875rem',
      xxxxlarge: '2.25rem',
      xxxxxlarge: '3rem',
      xxxxxxlarge: '4rem',
    },
    fontWeight: {
      regular: 'var(--typography-font-weight-regular)',
      medium: 'var(--typography-font-weight-medium)',
      semibold: 'var(--typography-font-weight-semibold)',
      bold: 'var(--typography-font-weight-bold)',
      heavy: 'var(--typography-font-weight-heavy)',
    },
    leading: {
      tighter: 'var(--typography-leading-tighter)',
      tight: 'var(--typography-leading-tight)',
      base: 'var(--typography-leading-base)',
      loose: 'var(--typography-leading-loose)',
      looser: 'var(--typography-leading-looser)',
    },
  },
};
export type LightThemeType = typeof lightTheme;
